module.exports = __webpack_public_path__ + "img/figma.f8d5de83.svg";